import { Box, Button, Checkbox, Flex, Grid, HStack,  Select, SimpleGrid, Spacer, Stack, Text, } from "@chakra-ui/react"
import { Link, useSearchParams,useLocation } from "react-router-dom"
import React, { useState, useEffect} from "react"
import CardProduct from "./CardPage"
import { useDispatch, useSelector } from "react-redux"
import { getProducts } from "../Redux/ProductReducer/productAction"
import { Pagination } from "../components/Pagination"
import { SideBar } from "../components/SideBar"



const baseurl = "https://anthro-backen.onrender.com/clothing"

function Clothing() {

    const {products,totalCount}=useSelector(store=>{
        console.log(store)
        return store.productReducer
    })

    
    const [searchParams,setSearchParams]=useSearchParams()
    const [page, setPage] = useState(1)
    const [totalPages, setTotal] = useState(0)
    const [data, setData] = useState([])
    const [sortPrice,setSortPrice]=useState("")


    const dispatch=useDispatch()
    const location=useLocation()

    console.log("location",location)
    console.log("check order coming or not",searchParams.get("order"))

    const obj={
        params:{
           // _page:page,
            _sort:searchParams.get("order") && "price",
            _order:searchParams.get("order"),
          //  _limit:15,
        }
    }

   

    const handleAdd=(page)=>{
        setPage(prev=>prev+1)
    }

    const handleReduce=()=>{
        setPage(prev=>prev-1) 
    }


    useEffect(() => {

        dispatch(getProducts(baseurl,obj))

        setData(products)
        setTotal(prev=>Math.ceil(Number(totalCount)/15))
       
    }, [page,searchParams,sortPrice])

    const handleSort=()=>{
        let newObj={
            params:{
                _sort:sortPrice && "price",
                _order:sortPrice
            }
        }
        dispatch(getProducts(baseurl,newObj))
    }

    return (
        <Box w={"100%"} m={"auto"}  >
            <Box m={"auto"} w={"95%"} >
                <Box mt={5} bg="red.10">
                    <Flex alignItems={"center"} justifyContent={"space-evenly"} justifyItems={"center"} padding={5} >
                        <Button m={2} left={0} padding={8}bg="red.50"><Link>WEDDING GUEST DRESSES</Link></Button>
                        <Button m={2} padding={8} bg="red.50"><Link> CAUSAL DRESSES</Link></Button>
                        <Button m={2} padding={8} bg="red.50"><Link> PARTY DRESSES</Link></Button>
                        <Button m={2} padding={8} bg="red.50"><Link>WORK DRESSES</Link></Button>
                        <Button m={2} padding={8} bg="red.50"><Link> VACTION DRESSES</Link></Button>
                        <Button padding={8} bg="red.50"><Link > FROMAL DRESSES</Link></Button>
                    </Flex>
                    <hr></hr>
                </Box>


                <Box w={"100%"}>
                    <SimpleGrid display={"flex"}>
                       
                        <Box w={"21%"} bg={"orange.50"}>{<SideBar/>}</Box>
                        <Spacer />
                        <Box w={"78%"} >

                            <HStack>
                                <Text>Dresses : {totalCount}

                                </Text>
                                <Spacer />
                                <Select placeholder='Select option' w="200px" onChange={(e)=>setSortPrice(e.target.value)} >
                                    <option value='asc'>Low-High</option>
                                    <option value='desc'>High-Low</option>
                                    <option value='option3'>A-Z</option>
                                </Select>

                                <HStack>
                                    <Button  disabled={page===1} onClick={handleReduce}>Prev</Button>
                                    <Text>{page} / {totalPages}</Text>
                                    <Button disabled={page===4} onClick={handleAdd}>Next</Button>

                                    {/* <Box>{<Pagination
                                        key={page}
                                        totalPages={totalPages}
                                        page={page}
                                        setPage={setPage}
                                    />}</Box> */}

                                </HStack>

                            </HStack>

                            <Box >
                         
                                
                            <Grid templateColumns='repeat(3, 1fr)' gap={6}>
                                                 
                            {data.map((ele, id) => {
                               
                                  return( 
                                     <CardProduct
                                    key={ele.id}
                                    {...ele}
                                   // handleCart={}
                                    />
                                  )}
                                    )}
                                   
                            </Grid>
                                                       

                            </Box>

                        </Box>

                    </SimpleGrid>
                </Box>

            </Box>
        </Box>
    )
}


export default Clothing